//备案用
import layout from '@/views/local/layout';
export default [
  {
    path: '/local',
    component: layout,
    redirect: '/local',
    children : [
      {
        path: '/local',
        name: 'local',
        component: () => import('@/views/local/index.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/local/goods_detail',
        name: 'goods_detail',
        component: () => import('@/views/local/detail.vue'),
        meta: {
          title: '详情'
        }
      },
      {
        path: '/local/order',
        name: 'local_order',
        component: () => import('@/views/local/order.vue'),
        meta: {
          title: '订单确认'
        }
      }
    ]
  },
  {
    path: '/local/register_login',
    name: 'register_login',
    component: () => import('@/views/local/login.vue'),
    meta: {
      title: '登录'
    }
  }
]